import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=26132290&scoped=true&"
import script from "./AddressField.vue?vue&type=script&lang=ts&"
export * from "./AddressField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26132290",
  null
  
)

/* custom blocks */
import block0 from "./AddressField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports